<template>
    <table class="gc-listing">
        <thead class="header">
            <td class="field__intro" style="width: 200px;">
                Name
            </td>
            <td class="field__intro">
                Competition
            </td>
            <td class="header__actions">
                Actions
            </td>
        </thead>
        <tbody class="">
            <h2 class="section-header">Live Club Pages</h2>
            <tr class="form-card" v-for="(club, index) in sortedClubPages" :key="index">
                <td class="form-card__intro  fixed-width">
                    {{ club.attributes.club.name }} 
                </td>
                <td class="form-card__intro flex-width competitions"
                >
                <div v-for="(competition, i) in competitions" :key="i" 
                v-if="competition.competitionID === club.attributes.club.competitionID">
                    {{ competition.competitionName  }}
                </div>
                   
                </td>
                <td class="form-card__actions  fixed-width-actions">
                    <v-icon class="form-card__action" @click="editClub(club.id)">edit</v-icon>
                    <confirmation-modal
                        @confirmed="deleteClub(club.id)"
                        title="Delete Club Page"
                        text="This action is permanent, are you sure you want to delete this club page?"
                    >
                        <v-icon class="form-card__action">delete</v-icon>
                    </confirmation-modal>
                </td>
            </tr> 
        </tbody>
        <tbody class="">
            <h2 class="section-header">Inactive Club Pages</h2>
            <tr class="form-card" v-for="(club, index) in sortedInactiveClubPages" :key="index">
                <td class="form-card__intro fixed-width">
                    <p v-if="club.attributes.club.hidden" class="page-item__status status__hidden">Hidden</p>
                    {{ club.attributes.club.name }} 
                </td>
                <td class="form-card__intro flex-width">
                    <div v-for="(competition, i) in competitions" :key="i"  
                        v-if="competition.competitionID === club.attributes.club.competitionID">
                        {{ competition.competitionName  }}
                    </div>
                </td>
                <td class="form-card__actions fixed-width-actions">
                    <v-icon class="form-card__action" @click="editClub(club.id)">edit</v-icon>
                    <v-icon class="form-card__action" @click="deleteClub(club.id)">delete</v-icon>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import axios from "axios"
import ConfirmationModal from "@/components/Library/GlobalModals/ConfirmationModal";
export default {
    name: "ClubListing",
    components: {
        ConfirmationModal
    },
    props: {
        clubs: {
            type: Array,
            required: true
        },
        competitions: {
            type: Array,
            required: true
        },
        inactiveClubs: {
            type: Array
        },
        liveClubs: {
            type: Array
        }
    },
    data: () => ({
        deleteApi: `${process.env.VUE_APP_CLUBS_SINGLEAPI}`,
        competitionId: null,
        competitionName: null,
        clubsData: [],
        competitionData: []
    }),
    created() {
        this.setData()
    },
    computed: {
        sortedClubPages() {
            return this.liveClubs.slice().sort((a, b) => {
                if (a.attributes.club.name < b.attributes.club.name) return -1;
                if (a.attributes.club.name > b.attributes.club.name) return 1;
                return 0;
            });
        },
        sortedInactiveClubPages() {
            return this.inactiveClubs.slice().sort((a, b) => {
                if (a.attributes.club.name < b.attributes.club.name) return -1;
                if (a.attributes.club.name > b.attributes.club.name) return 1;
                return 0;
            });
        }
    },
    methods: {
        setData() {
            this.clubsData = this.clubs
            this.competitionData = this.competitions
        },
        editClub(clubId) {   
            this.$router.push({
                name: "Edit Club",
                params: {
                    id: clubId
                }
            })
            console.log('newcomp', this.competitions)

            this.$emit('competitions', this.competitions)
        },

        deleteClub(clubId) {
            if (confirm("Are you sure you want to delete this club page")) {
                if (clubId) {
                    this.$getCurrentUserJwToken().subscribe((jwt) => {
                        axios({
                            method: "DELETE",
                            url: `${this.deleteApi}/${clubId}`,
                            headers: { "Authorization": jwt }
                        })
                        .then(response => {
                            console.log("Club page deleted:", response);
                            this.setData()
                            window.location.reload();
                        })
                        .catch(e => {
                            console.error("Problem deleting club page", e);
                        });
                    })
                } 
            }
        }
    }
}
</script>

<style scoped lang='scss'>
.section-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
}
.confirmation-modal {
    display: inline-block;
    cursor: pointer;
}
.form-card {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 15px 0;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 80px;
    &__intro {
        margin: 16px 16px 8px;
        &.fixed-width {
            width: 200px;
        }
        &.flex-width {
            flex-grow: 1;
            text-align: center;
        }
    }
    &__actions {
        background-color: #E6E8F1;
        height: 100%;
        padding: 24px 16px;

        &.fixed-width-actions {
            width: 100px;
        }
    }
    &__action {
        margin: 0 8px 0 0;
        i {
            color: #67247c;
        }
    }
}

.page-item {
    position: relative;
    &__status {
      padding: 3px 12px;
      margin: 0 8px 0 0;
      font-size: 10px;
      color: #fff;
      background-color: color(hiddenHighlight);
      border-radius: 4px;
      display: inline;

    }
}

.view-more {
    width: 180px;
    height: 30px;
    background: grey;
}

.header {
    background: #67247c;
    padding: 10px;
    display: flex;
    width: 100%;
    color: white;
    

    .field__intro, .header__actions { 
        flex-grow: 1;
        flex-basis: 33.3%;
        margin: 16px 16px 8px;
        
    }

    .field__intro  {
        &:first-of-type {
            text-align: left;
        }
        &:nth-of-type(2) {
            text-align: center;
        }

    }

    .header__actions {
        text-align: right;
    }
}
</style>
